export { EditarSetor } from './EditarSetor'
